import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { generatePath, useHistory } from 'react-router-dom'
import { KeyActionButton } from './KeyActionButton'
import { DESIGN_PATH, DOC_PATH } from 'paths'

export interface SubmitReviewButtonProps {
  request: InformalFeedbackRequest
}

export const SubmitReviewButton = ({ request }: SubmitReviewButtonProps) => {
  const history = useHistory()

  return (
    <KeyActionButton
      reviewType={request.type}
      label="Finish"
      onPress={() => {
        if (request.article) {
          history.push({
            pathname: generatePath(DOC_PATH, { slug: request.article.slug }),
            search: 'submitReview=true',
          })
        } else {
          history.push({
            pathname: generatePath(DESIGN_PATH, { key: request.design.key }),
            search: 'submitReview=true',
          })
        }
      }}
    />
  )
}
